import React from "react";

const PadLock = ({
  color = "#98A2B3",
  width = 16,
  height = 16,
}: {
  color?: string;
  height?: number;
  width?: number;
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.999 2.17a2.333 2.333 0 00-2.334 2.333v1.666H4.332V4.503a3.667 3.667 0 017.333 0v1.666h-1.333V4.503a2.333 2.333 0 00-2.333-2.334z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.835 5.5H2.168v9.667h11.667V5.5zM9 9.333h-2v2h2v-2z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default PadLock;
